exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".company-row[data-v-0bd7ad8c] {\n  margin-left: 10px;\n  margin-right: 10px;\n  margin-bottom: 15px;\n  display: flex;\n  align-content: center;\n  justify-content: flex-start;\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  background: #efefef;\n  border-radius: 25px;\n  cursor: pointer;\n}\n.company-row.selected[data-v-0bd7ad8c] {\n  color: #fff;\n  background: #2a2e81;\n}\n#companies-body[data-v-0bd7ad8c] {\n  width: 100%;\n}", ""]);

// exports
